import { render, staticRenderFns } from "./createOrganization.vue?vue&type=template&id=54d08ad6&"
import script from "./createOrganization.vue?vue&type=script&lang=js&"
export * from "./createOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports